import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { forwardRef, useState } from 'react';
import { IconEye } from "@frameio/vapor-icons/build/esm/icons/IconEye";
import { IconEyeSlash } from "@frameio/vapor-icons/build/esm/icons/IconEyeSlash";
import styled from 'styled-components';
import { hideVisually } from 'polished';
import { theme, whenActive, whenFocused, whenHovered } from "../../theme";
import { TextField } from "../TextField";
var TEXT = {
  showPassword: 'Show password',
  hidePassword: 'Hide password'
};
var HiddenText = styled.span.withConfig({
  displayName: "PasswordField__HiddenText",
  componentId: "vapor__sc-7gc5h6-0"
})(hideVisually);
var PasswordRevealToggleButton = styled.button.withConfig({
  displayName: "PasswordField__PasswordRevealToggleButton",
  componentId: "vapor__sc-7gc5h6-1"
})(["appearance:none;background-color:", ";border:none;color:", ";cursor:pointer;display:inline-flex;margin:0;outline:none;padding:0;", ",", ",", "{color:", ";}"], theme.colors.palette.transparent, theme.colors.palette.grey60, whenHovered, whenFocused, whenActive, theme.colors.palette.grey80);
export var PasswordField = forwardRef(function (_ref, forwardedRef) {
  var size = _ref.size,
      props = _objectWithoutProperties(_ref, ["size"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isRevealed = _useState2[0],
      setIsRevealed = _useState2[1];

  var toggleReveal = function toggleReveal() {
    return setIsRevealed(function (prev) {
      return !prev;
    });
  };

  var RevealIcon = isRevealed ? IconEyeSlash : IconEye;
  return /*#__PURE__*/React.createElement(TextField, _extends({}, props, {
    ref: forwardedRef,
    adornmentAfter: /*#__PURE__*/React.createElement(PasswordRevealToggleButton, {
      onClick: toggleReveal,
      type: "button"
    }, /*#__PURE__*/React.createElement(HiddenText, null, isRevealed ? TEXT.hidePassword : TEXT.showPassword), /*#__PURE__*/React.createElement(RevealIcon, {
      size: 16
    })),
    size: size,
    type: isRevealed ? 'text' : 'password'
  }));
});